import get from 'lodash.get';
import { findPillar } from './find-pillar';
const getString = (obj, selector, fallbackValue) => {
    const found = get(obj, selector);
    if (typeof found === 'string') {
        return found;
    }
    if (fallbackValue !== undefined) {
        return fallbackValue;
    }
    throw new Error(`expected string at '${selector}', got '${found}', in '${JSON.stringify(obj)}'`);
};
const getArray = (obj, selector, fallbackValue) => {
    const found = get(obj, selector);
    if (Array.isArray(found)) {
        return found;
    }
    if (fallbackValue !== undefined) {
        return fallbackValue;
    }
    throw new Error(`expected array at '${selector}', got '${found}', in '${JSON.stringify(obj)}'`);
};
const getLink = (data, { isPillar }) => {
    const title = getString(data, 'title');
    return {
        title,
        longTitle: getString(data, 'longTitle', '') || title,
        url: getString(data, 'url'),
        pillar: isPillar ? findPillar(getString(data, 'title')) : undefined,
        children: getArray(data, 'children', []).map((l) => getLink(l, { isPillar: false })),
        mobileOnly: false,
    };
};
const rrLinkConfig = 'readerRevenueLinks';
const buildRRLinkCategories = (data, position) => ({
    subscribe: getString(data, `${rrLinkConfig}.${position}.subscribe`, ''),
    support: getString(data, `${rrLinkConfig}.${position}.support`, ''),
    contribute: getString(data, `${rrLinkConfig}.${position}.contribute`, ''),
    gifting: getString(data, `${rrLinkConfig}.${position}.gifting`, ''),
});
const buildRRLinkModel = (data) => ({
    header: buildRRLinkCategories(data, 'header'),
    footer: buildRRLinkCategories(data, 'footer'),
    sideMenu: buildRRLinkCategories(data, 'sideMenu'),
    ampHeader: buildRRLinkCategories(data, 'ampHeader'),
    ampFooter: buildRRLinkCategories(data, 'ampFooter'),
});
// TODO refactor now that we know data must be CAPINavType.
export const extractNAV = (data) => {
    let pillars = getArray(data, 'pillars');
    pillars = pillars.map((link) => getLink(link, { isPillar: true }));
    const subnav = get(data, 'subNavSections');
    return {
        pillars,
        otherLinks: {
            url: '',
            title: 'More',
            longTitle: 'More',
            more: true,
            children: getArray(data, 'otherLinks', []).map((l) => getLink(l, { isPillar: false })),
        },
        brandExtensions: getArray(data, 'brandExtensions', []).map((l) => getLink(l, { isPillar: false })),
        currentNavLink: getString(data, 'currentNavLinkTitle', ''),
        subNavSections: subnav
            ? {
                parent: subnav.parent
                    ? getLink(subnav.parent, { isPillar: false })
                    : undefined,
                links: getArray(subnav, 'links').map((l) => getLink(l, { isPillar: false })),
            }
            : undefined,
        readerRevenueLinks: buildRRLinkModel(data),
    };
};
